import "./index.scss";
import React, { useState } from "react";

import { useTranslation } from "react-i18next";
import ProfileImageForm from "../../component/parametreForms/profileImageForm";
import ChangePasswordForm from "../../component/parametreForms/changePasswordForm";
import PersonalInfoForm from "../../component/parametreForms/personalInfoForm";
import ClientLayout from "../../component/appLayouts/clientLayout/clientLayout";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
function Parametres() {
  const [selectedTab, setSelectedTab] = useState(1);
  const { t } = useTranslation();

  return (
    <ClientLayout>
      <section id="Parametres-page" className="Parametres-page mt-4">
        <div className="worko-tabs">
          <input
            className="state"
            type="radio"
            title="tab-one"
            name="tabs-state"
            id="tab-one"
            readOnly
            checked={selectedTab === 1}
            onClick={() => setSelectedTab(1)}
          />
          <input
            className="state"
            type="radio"
            title="tab-two"
            name="tabs-state"
            id="tab-two"
            readOnly
            checked={selectedTab === 2}
            onClick={() => setSelectedTab(2)}
          />
          <input
            className="state"
            type="radio"
            title="tab-three"
            name="tabs-state"
            id="tab-three"
            readOnly
            checked={selectedTab === 3}
            onClick={() => setSelectedTab(3)}
          />
          <input
            className="state"
            type="radio"
            title="tab-four"
            name="tabs-state"
            id="tab-four"
            readOnly
            checked={selectedTab === 4}
            onClick={() => setSelectedTab(4)}
          />

          <div className="tabs flex-tabs">
            <div className="flex-tabs">
              <label htmlFor="tab-one" id="tab-one-labels" className="tabss">
                {t("Profile")}
              </label>
              <label htmlFor="tab-two" id="tab-two-labels" className="tabss">
                {t("Sécurité")}
              </label>
            </div>
            <div id="tab-one-panel" className="panel active">
              <div className="profile-image-container">
                <ProfileImageForm />
              </div>
              <br />

              <hr />
              <div className="personal-info-container">
                <PersonalInfoForm />
              </div>
            </div>
            <div id="tab-two-panel" className="panel">
              <h4>{t("Changer mot de passe")}</h4>
              <br />
              <hr />
              <div className="update-pwd-container">
                <ChangePasswordForm />
              </div>
            </div>
          </div>
        </div>
      </section>
      <ToastContainer />
    </ClientLayout>
  );
}

export default Parametres;
